var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingBishopShipworks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2623 1814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0b8fb3;\n      }\n\n      .cls-2 {\n        fill: #0b92b6;\n      }\n\n      .cls-3 {\n        fill: #43363f;\n      }\n\n      .cls-4 {\n        fill: #0fc3f4;\n      }\n\n      .cls-5 {\n        fill: #1c1118;\n      }\n\n      .cls-6 {\n        fill: #584653;\n      }\n\n      .cls-7 {\n        fill: #0c94b9;\n      }\n\n      .cls-8 {\n        fill: #0b90b4;\n      }\n\n      .cls-9 {\n        isolation: isolate;\n      }\n\n      .cls-10 {\n        fill: #443741;\n      }\n\n      .cls-11 {\n        fill: #574652;\n      }\n\n      .cls-12 {\n        fill: #1b1017;\n      }\n\n      .cls-13 {\n        fill: #241620;\n      }\n\n      .cls-14 {\n        fill: #0c95ba;\n      }\n\n      .cls-15 {\n        fill: #0b91b5;\n      }\n\n      .cls-16 {\n        fill: #0c96bb;\n      }\n\n      .cls-17 {\n        fill: #0c93b7;\n      }\n\n      .cls-18 {\n        fill: #40333c;\n      }\n\n      .cls-19 {\n        fill: #0b92b7;\n      }\n\n      .cls-20 {\n        fill: #473943;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Game_Layer"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "2571.3 0 2400.29 0 2458.4 0 2629.41 0 2571.3 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2341.87 377.61 2170.86 377.61 2400.29 0 2571.3 0 2341.87 377.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2170.86,
    y: 377.61,
    width: 171.01,
    height: 831.63
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2201.6 1809.97 2030.59 1809.97 2170.86 1209.24 2341.87 1209.24 2201.6 1809.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2249.08 1812.03 2078.07 1812.03 2030.59 1809.97 2201.6 1809.97 2249.08 1812.03"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1591.09,
    y: 910.97,
    width: 171.01,
    height: 210
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1762.1 910.97 1591.09 910.97 1514.01 850.97 1685.02 850.97 1762.1 910.97"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1514.01,
    y: 1120,
    width: 171.01,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1514.01,
    y: 852,
    width: 171.01,
    height: 267.99
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1685.02 851 1762.08 911 1762.08 1121 1685.02 1121 1685.02 1120 1685.02 852 1685.02 851"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1514.01,
    y: 851,
    width: 171.01,
    height: 1.01
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1099.59 1120.97 928.58 1120.97 1514.01 1119.97 1685.02 1119.97 1099.59 1120.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1098.45 852 927.44 852 928.58 851 1099.59 851 1098.45 852"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1060.17 885.95 889.16 885.95 927.44 852 1098.45 852 1060.17 885.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1031.93 1120.97 860.92 1120.97 928.58 1120.97 1099.59 1120.97 1031.93 1120.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1031.93 911 860.92 911 889.16 885.95 1060.17 885.95 1031.93 911"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1099.59 851 1099.59 852 1099.59 1120 1099.59 1121 1031.93 1121 1031.93 911 1060.17 885.95 1098.45 852 1099.59 851"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 860.92,
    y: 911,
    width: 171.01,
    height: 210
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M222.72.03h2348.59s-229.45,373.8-229.45,373.8l-.46,835.46-140.95,603.69H593.58s-111.72-478.4-111.72-478.4l-29.24-126.34V378.34L222.72.03ZM1762.1,1120.97v-210l-77.08-60-288,1.03h-297.43s-3.22,0-3.22,0l-36.19,33.94-28.24,25.03v210h67.66s585.43-1,585.43-1l77.08,1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2629.41 0 2388.85 388.89 2388.85 1215.36 2249.08 1812.03 2201.6 1809.97 2341.87 1209.24 2341.87 377.61 2571.3 0 2629.41 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "593.58 1812.97 422.57 1812.97 310.86 1334.57 481.87 1334.57 593.58 1812.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "592.4 1811.97 421.39 1811.97 373.91 1811.03 544.92 1811.03 592.4 1811.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "481.87 1334.57 310.86 1334.57 281.62 1208.23 452.63 1208.23 481.87 1334.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 281.62,
    y: 378.34,
    width: 171.01,
    height: 829.89
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "544.92 1811.03 373.91 1811.03 234.15 1212.36 405.16 1212.36 544.92 1811.03"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 234.15,
    y: 385.89,
    width: 171.01,
    height: 826.46
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "222.72 .03 51.71 .03 2400.3 .03 2571.31 .03 222.72 .03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "452.63 378.34 281.62 378.34 51.71 .03 222.72 .03 452.63 378.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "164.6 0 -6.41 0 51.7 0 222.71 0 164.6 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "405.16 385.89 234.15 385.89 -6.41 0 164.6 0 405.16 385.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "222.71 0 452.15 370.83 452.15 377.61 452.15 1206.24 481.86 1334.57 592.4 1811.97 544.92 1811.03 405.16 1212.36 405.16 385.89 164.6 0 222.71 0"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1187.63 1198.39 1050.82 1198.39 1032.02 1182.12 1168.83 1182.12 1187.63 1198.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1898.98 1120.55 1898.98 1182.12 1880.18 1198.39 1187.63 1198.39 1168.83 1182.12 1168.83 1120.55 1898.98 1120.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1032.02,
    y: 1120.55,
    width: 136.81,
    height: 61.58
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "1168.83 1120.55 1032.02 1120.55 1762.17 1120.55 1898.98 1120.55 1168.83 1120.55"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 714.02,
    y: 0,
    width: 170.08,
    height: 1813.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 708.89,
    y: 0,
    width: 5.13,
    height: 1813.99
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "714.02 0 708.89 0 878.98 0 884.11 0 714.02 0"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1923.02,
    y: 0,
    width: 170.09,
    height: 1813.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1917.89,
    y: 0,
    width: 5.13,
    height: 1813.99
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1923.02 0 1917.89 0 2087.98 0 2093.11 0 1923.02 0"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1721.14 622.18 1695.49 622.18 1657.21 499.62 1682.86 499.62 1721.14 622.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1682.86 499.62 1657.21 499.62 1546.19 435.65 1571.84 435.65 1682.86 499.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1785.69 670.64 1760.04 670.64 1544.82 667.31 1570.48 667.31 1785.69 670.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "1489.72 699.55 1464.07 699.55 1520.82 619.48 1546.47 619.48 1489.72 699.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1486.93 699.55 1461.28 699.55 1464.07 699.55 1489.72 699.55 1486.93 699.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1571.84 435.65 1546.19 435.65 1461.28 210.89 1486.93 210.89 1571.84 435.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1376.43,
    y: 208.21,
    width: 25.65,
    height: 491.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1398.55 699.55 1372.9 699.55 1376.43 699.55 1402.08 699.55 1398.55 699.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1394.5 101.81 1368.85 101.81 1420.01 37 1445.67 37 1394.5 101.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1375.47 747.01 1349.82 747.01 1288.35 667.27 1314 667.27 1375.47 747.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "1271.88 402.73 1246.23 402.73 1368.85 101.81 1394.5 101.81 1271.88 402.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1160.33 622.18 1134.67 622.18 1311.16 619.45 1336.81 619.45 1160.33 622.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1159.19 467.65 1133.53 467.65 1246.23 402.73 1271.88 402.73 1159.19 467.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1722.29,467.65l63.4,203-215.21-3.33-56.5,79.7h-138.51s-61.47-79.74-61.47-79.74l-218.22,3.38,63.4-203,112.69-64.92,122.62-300.92,51.17-64.81,50.84,65.75,113.39,300.15,112.39,64.75ZM1402.08,699.55V208.21l-92.75,227.62-110.72,63.79-38.29,122.56,176.49-2.73,61.74,80.1h3.53M1546.47,619.48l174.67,2.7-38.28-122.56-111.02-63.96-84.91-224.76v488.66h2.79s56.76-80.08,56.76-80.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1095.78 670.64 1070.13 670.64 1133.53 467.65 1159.19 467.65 1095.78 670.64"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingBishopShipworks);
export default __webpack_public_path__ + "static/media/building-bishop-shipworks.66877f61f25097be2ddc4e740b042375.svg";
export { ForwardRef as ReactComponent };